import { Box, useColorModeValue, useStyleConfig } from "@chakra-ui/react";

function Card(props) {
  const bgColorCard = useColorModeValue( "white", "");
  const { variant, children, ...rest } = props;
  const styles = useStyleConfig("Card", { variant });
  // Pass the computed styles into the `__css` prop
  return (
    <Box 
      {...rest} 
      style={{backgroundColor: bgColorCard}} 
      width='100%'
      height="100%"
      p={5}
    >
      {children}
    </Box>
  );
}

export default Card;
